import { useState } from "react";
import { Package } from "lucide-react";
import type { ProductHistory } from "../../types/sales";
import { ExpandableProductRow } from "../ExpandableProductRow";

interface Props {
  products: ProductHistory[];
}

const ProductSalesTable: React.FC<Props> = ({ products }) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div className="bg-white rounded-lg shadow-md overflow-x-auto">
      <table className="w-full text-sm min-w-[500px] text-left">
        <thead className="border-b bg-primary text-white">
          <tr>
            <th className="py-3 px-4">#</th>
            <th className="py-3 px-4">Product</th>
            <th className="py-3 px-4">Store</th>
            <th className="py-3 px-4">Price</th>
            <th className="py-3 px-4">Sold</th>
            <th className="py-3 px-4">Revenue</th>
            <th className="py-3 px-4">Remaining</th>
            <th className="py-3 px-4"></th>
          </tr>
        </thead>

        {products.length > 0 ? (
          <tbody>
            {products.map((product, index) => {
              const isOpen = expandedId === product.id;

              return (
                <>
                  <tr
                    key={product.id}
                    className="border-b hover:bg-gray-50 cursor-pointer"
                    onClick={() =>
                      setExpandedId(isOpen ? null : product.id)
                    }
                  >
                    <td className="px-4 py-3">{index + 1}</td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        {product.image_url ? (
                          <img src={product.image_url} alt={product.name} className="w-8 h-8 rounded object-cover flex-shrink-0" />
                        ) : (
                          <Package size={20} className="text-gray-400 flex-shrink-0" />
                        )}
                        {product.name}
                      </div>
                    </td>
                    <td className="px-4 py-3">{product.store}</td>
                    <td className="px-4 py-3">GHS {product.sellingPrice}</td>
                    <td className="px-4 py-3">{product.totalSold}</td>
                    <td className="px-4 py-3">GHS {product.totalRevenue}</td>
                    <td className="px-4 py-3">{product.remainingStock}</td>
                    <td className="text-primary font-bold">
                      {isOpen ? "−" : "+"}
                    </td>
                  </tr>

                  {isOpen && (
                    <ExpandableProductRow product={product} />
                  )}
                </>
              );
            })}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td
                colSpan={7}
                className="py-6 text-center text-gray-500"
              >
                No product records available
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
};

export default ProductSalesTable;
